<script>
	import Table from './Table.svelte';
	import "bulma/css/bulma.css";
</script>
<section class="section">
	<div class="container">
		<Table />
	</div>
</section>


